<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body text-center py-5">
        <h5>{{ title }}</h5>
        <p class="text-muted">Esta sección estará disponible próximamente.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderPage',
  props: {
    title: { type: String, default: 'En construcción' },
  },
};
</script>
